import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from '@core/services/theme.service';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faAddressCard,
  faAngleLeft,
  faAngleRight,
  faArrowDown,
  faArrowRight,
  faArrowRightFromBracket,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleExclamation,
  faCircleQuestion,
  faCircleXmark,
  faClipboard,
  faClone,
  faCode,
  faCodeFork,
  faCompress,
  faCubes,
  faDownload,
  faExpand,
  faEye,
  faEyeSlash,
  faFaceMeh,
  faFileCode,
  faFileContract,
  faFileImage,
  faFingerprint,
  faFlask,
  faFloppyDisk,
  faGaugeHigh,
  faGear,
  faGears,
  faHammer,
  faHouse,
  faImage,
  faImages,
  faMagnifyingGlass,
  faMessage,
  faMinus,
  faPaste,
  faPencil,
  faPlus,
  faQuestion,
  faRobot,
  faRocket,
  faScrewdriver,
  faScrewdriverWrench,
  faShieldHalved,
  faSliders,
  faSpaceShuttle,
  faSpinner,
  faTerminal,
  faTrash,
  faUpDown,
  faUser,
  faUserAstronaut,
  faUsers,
  faUserTie,
  faWandMagicSparkles,
  faWrench,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { AlertContainerComponent } from '@group24ag/flowkit';
import { FaviconService } from '@core/services/favicon.service';
import { environment } from '@environment/environment';

@Component({
  selector: 'app-root',
  imports: [AlertContainerComponent, RouterOutlet],
  template: `
    <flk-alert-container></flk-alert-container>
    <router-outlet></router-outlet>
  `,
})
export class AppComponent implements OnInit {
  /**
   * INJECTIONS
   * **/

  /** Favicon Service */
  private readonly faviconService: FaviconService = inject(FaviconService);

  /** Theme Service */
  private readonly themeService: ThemeService = inject(ThemeService);

  /** FontAwesome Icon Library */
  private readonly libraryService: FaIconLibrary = inject(FaIconLibrary);

  constructor() {
    this.libraryService.addIcons(
      faXmark,
      faPlus,
      faEye,
      faEyeSlash,
      faCubes,
      faSpaceShuttle,
      faMinus,
      faChevronRight,
      faCompress,
      faExpand,
      faUpDown,
      faPencil,
      faFingerprint,
      faWrench,
      faCircleQuestion,
      faChevronUp,
      faChevronLeft,
      faChevronDown,
      faSpinner,
      faQuestion,
      faRocket,
      faFaceMeh,
      faArrowDown,
      faCodeFork,
      faFileCode,
      faMagnifyingGlass,
      faTrash,
      faFloppyDisk,
      faScrewdriverWrench,
      faSliders,
      faHammer,
      faHouse,
      faMessage,
      faGear,
      faGears,
      faAngleRight,
      faAngleLeft,
      faArrowRightFromBracket,
      faFlask,
      faCheck,
      faUser,
      faShieldHalved,
      faFileContract,
      faAddressCard,
      faCircleCheck,
      faCircleXmark,
      faCircleExclamation,
      faGaugeHigh,
      faSpaceShuttle,
      faUsers,
      faScrewdriver,
      faTerminal,
      faUserAstronaut,
      faCode,
      faImage,
      faClipboard,
      faClone,
      faArrowRight,
      faPaste,
      faUserTie,
      faWandMagicSparkles,
      faImages,
      faFileImage,
      faFingerprint,
      faRobot,
      faDownload
    );
  }

  ngOnInit() {
    this.faviconService.setFavicon(environment.name);
  }
}
